<template>
    <!--CREAR COMPAÑIA-->

    <v-layout>
        <v-dialog v-model="modalregister" style="z-index:1000"  max-width="800" persistent> 
            <v-card style="background:white">  
                <div class="J-header" style="padding-top:8px">
                        <div class="col-xs-7 col-md-7 col-lg-11"  v-show="tab[0].visible" >
                            <h5 style="font-family: sans-serif;" class=" tamañoTitulo modal-title" id="exampleModalCenterTitle" >Crear negocio</h5>
                        </div>
                        <button @click="modalregister = false"
                            color="success" class="btn btn-link">
                                <i class="fas fa-times"></i> 
                        </button>
                        <v-menu
                            offset-y
                            content-class="dropdown-menu"
                            transition="slide-y-transition">
                            <button slot="activator"
                            color="success" class="btn btn-link">
                                <i class="fas fa-angle-down"></i> 
                            </button>
                            <v-list dense class="J-list" v-for="(item,index) in tab"
                                :key="item.id">
                                <button class="btn btn-link J-btn" @click="isTabActive(index)">
                                    {{item.title}}
                                </button>
                            </v-list>
                        </v-menu>
                </div>
                <div v-show="tab[0].visible">
                    <form @submit.prevent="createCompany()">
                        <div class="modal-body" >
                            <div style="text-align: center;padding: 10px;">                  
                                <div class="form-group">
                                    <div class="form-row">
                                        <label class="col-md-5">Código de Identificación Tributaria <br> (RUC,DNI,CUIT, Otros)</label>
                                        <div class="col-md-7 form-row">
                                            <input required v-model="company.ruc" name="ruc" type="number" style="height:30px" class="col-11 form-control" placeholder="RUC">
                                            <span v-if="!showiconsearchingruc"  class="active col-1 icon-container" style="display: block;">
                                                <i @click="validatorRuc()" style="color:#0d6193;cursor: pointer;" class="fas fa-search"></i>
                                            </span>
                                            <span v-else class="inactive col-1 icon-container" style="display: block;">
                                                <i class="loader"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div> 
                                <div class="form-group">
                                    <div class="form-row">
                                        <label class="col-md-5">Nombre del negocio:</label>
                                        <div class="col-md-7 form-row">
                                            <input required  v-model="company.name" name="name" type="text" class="col-md-11 form-control" placeholder="Nombre">
                                        </div>
                                    </div>
                                </div> 
                                <div class="form-group">
                                    <div class="form-row">
                                        <label class="col-md-5">Dirección:</label>
                                        <div class="col-md-7 form-row">
                                            <input required  v-model="company.address" type="text" class="col-md-11 form-control" placeholder="Dirección">
                                        </div>
                                    </div>
                                </div>   
                                <div class="form-group" v-if="false">
                                    <div class="form-row">
                                        <label class="col-md-5">Categoria:</label>
                                        <div class="col-md-7 form-row">
                                            <select v-model='company.category' class="col-md-11 form-control">
                                                <option value=''>--Seleccione--</option>
                                                <option v-for="category in dataCategory"  :value='category.value'>{{category.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>                                 
                            </div>
                            <div class="form-row">
                                <div class="col-md-6" style="padding:5px;">
                                    <button @click="modalregister = false" type="button" style="width: 100%;vertical-align:0 ;border:0 ; background: rgb(172, 175, 175);" class="btn btn-secondary">Cancelar</button>
                                </div>
                                <div class="col-md-6" style="padding:5px;">
                                    <button type="submit" style="width: 100%;vertical-align:0 ;border:0 ; background: linear-gradient(to bottom, #1b7aaf, #1f8aac, #0d6193);" class="btn btn-primary">Guardar Cambios</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div v-show="tab[1].visible" class="J-container-list">
                    <label v-if="dataCompanies.length<=0">No está vinculado a ningun negocio</label>
                    <v-flex xs12  v-for="item in dataCompanies" :key="item._id">
                        <v-card color="" class="dark--text J-btn--cursor" @click="isoffice=false; routeDirection(item);">
                            <v-layout class="J-layaut">
                                <v-flex xs3>
                                <v-img
                                    :src="item.image_company.length <= 0?'https://cdn.vuetifyjs.com/images/cards/foster.jpg' : item.image_company[0].link"
                                    height="125px"
                                
                                ></v-img>
                                </v-flex>
                                <v-flex xs9>
                                <v-card-title primary-title>
                                    <div>
                                    <div class="headline J-headline">{{item.name.toUpperCase()}}</div>
                                    </div>
                                </v-card-title>
                                </v-flex>
                            </v-layout>
                        </v-card>
                        <br>
                    </v-flex>
                </div>
            </v-card>
        </v-dialog>
    </v-layout> 
</template>
<script>
const alertify = require('alertifyjs')
//const axios = require('axios')
import env from '../../../config/env.example'

import initVue from '../../../helpers/initVue'
import { LMap, LTileLayer, LMarker,LPopup,LCircle,LCircleMarker } from 'vue2-leaflet';
import Company from '../../../models/company'
import {OfficeService,CompanyService} from '@/services/index.js'
import { EventBus } from '../../../helpers/eventbus/event-bus.js'

import {ReferredStorage} from '@/helpers/storage.js'

import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    computed: mapGetters({
        indetityU: 'getIdentity',
        tokenU: 'getToken'
    }),
    components:{
        LMap, LTileLayer, LMarker,LPopup,LCircle,LCircleMarker
    },
    data(){
        return{
            modalregister: false,
            company:new Company(),
            referredStorage:new ReferredStorage(),
            valid: true,
            dataCategory:[
                {
                    name:"Lavanderia",
                    value:"lavanderia"
                },
                {
                    name:"Restaurante",
                    value:"restaurante"
                },
                {
                    name:"Bodega",
                    value:"bodega"
                },
                {
                    name:"Proveedor",
                    value:"proveedor"
                },
                {
                    name:"Otro",
                    value:"otro"
                }
            ],
            latitude:-12.0454324, longitude:-75.2376588,
            
            tab:[
                {id:1,title:'Crear',visible:true,checked:false},
                {id:2,title:'Negocios',visible:false,checked:false}
                //{id:3, title:'Sedes',visible:false,checked:false}
            ],
            checkedRuc:false,
            dataCompanies:[],
            identity: null,
            token: null,
            session: false,
            rules: {
                required: value => !!value || 'Requerido.',
            },
            isoffice:false,
            dataoffice:[],
            showiconsearchingruc:false
        }
    },
    mounted(){
        this.getidentity()
        EventBus.$on('companyregister', () =>{
            this.openregistercompanymodal()
        })
        //this.getofficeadministration()
        //this.getCompany()
    },
    
    methods:{
        getofficeadministration(){
            var query={
                
            }
            OfficeService.list(query).then(res=>{
                //console.log(res)
                if(res.data.results!=null){
                    this.dataoffice=res.data.results.office;
                    //console.log(this.dataoffice);
                    this.isTabActive(2);
                }
            })
        },
        routeDirection:function(item){
            
            localStorage.removeItem('isoffice')
            let dataisoffice

            if(this.isoffice){
               dataisoffice = {isoffice:this.isoffice,  idoffice:item._id_office}
            }
            else{
                dataisoffice = {isoffice:this.isoffice,  idoffice: null}
            }

            localStorage.setItem('isoffice',JSON.stringify(dataisoffice))
            
            let routeiddirection
            if(this.isoffice){
                routeiddirection = item._id_company._id
            }else{
                routeiddirection = item._id
            }
            
            this.modalregister=false
            this.$router.push(`/empresa/created/${routeiddirection}`);
            
        },
        getCompany(){
            CompanyService.list()
            .then(res=>{
                const {data}=res.data;
                if(data.companies!=null){
                    this.dataCompanies=data.companies;                    
                    this.isTabActive(1);
                }

                })
            .catch(err=>{
                let msg = err
                
            })
        },
        isTabActive:function(index){
            for (let i = 0; i < this.tab.length; i++) {
              this.tab[i].visible=false;                
            }
            this.tab[index].visible=true;     
        },
        getidentity(){
            this.identity = initVue.getIdentity().identity
            this.token = initVue.getIdentity().token
            this.session = initVue.isLogged(this.identity, this.token)    
        },
        
        openregistercompanymodal(){
            try{
                this.getCompany();
            }
            catch($e){
                this.modalregister=true
                this.getCompany();
                console.log($e)
            }
        },
        createCompany:function(){
            if(!this.session) {
                alertify.error('Inicie sesión o registrese')
                return;
            }
            if(this.company.razon_social === ''){
                this.company.razon_social = this.company.name
            }
            var referred=this.referredStorage.get()
            if(referred&&referred!=''&&referred!=null){
                this.company.referred =referred
                
            }
            var url=`company/create`;
            this.company.category = "ropa"
            this.axios.post(url,this.company)
            .then(response=>{
                this.getCompany()
                this.company = new Company()
                this.referredStorage.remove()
            })
            .catch(error=>{
                let companyexist = error.response.data.message === 'company exist'
                let msghiguertwohundred = error.response.data.message === 'Superaste los límites solo puedes administrar 200 empresas'
                if(companyexist){
                    alertify.error('Existe una Lavandería ya registrada con estos datos')
                }else if(msghiguertwohundred){
                    alertify.error(error.response.data.message)
                }
                this.company = new Company()
            })
        },
        validatorRuc:async function(){
            this.showiconsearchingruc = true
           await this.axios.get(`entity/search/ruc/${this.identity._id}/${this.token}/${this.company.ruc}`)
            .then(response=>{
                this.checkedRuc=true;
                const {data} =response.data;
                this.company.name=data.razon_social;
                this.company.razon_social=data.razon_social;
                this.company.address=data.address;
                this.company.ubigeo=data.ubigeo;
                this.showiconsearchingruc = false
                //console.log(response)
                //this.createCompany()
            })
            .catch(error=>{
                //this.company = new Company()
            })
            if(this.checkedRuc){
                this.checkedRuc=false;
                return;
            }
           await axios.post('https://api.migoperu.pe/api/v1/ruc',{
               'ruc':this.company.ruc,
               'token':'837b52b5-44f9-4f0f-8c29-9b42666781b2-e584e59e-79cc-4277-921c-9a880dd5e9c5'
           })
           .then(response=>{
               const {data} =response;
               this.company.name=data.nombre_o_razon_social;
               this.company.razon_social=data.nombre_o_razon_social;
               this.company.address=data.direccion;
               this.company.ubigeo=data.ubigeo;
               this.showiconsearchingruc = false
               //console.log(response)
               //this.createCompany()
           })
           .catch(error=>{
               this.showiconsearchingruc = false
               //console.log(error)
               //this.company = new Company()
           })
        }

    },
    
        
}

    

</script>
<style scoped>
    
</style>
